module.exports = __webpack_public_path__ + "static/media/toyota-offer-2.9272e5b8.png";